import { ArrowRight } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

export const FinalCTASection = () => {
  return (
    <section
      className="relative"
      style={{
        background: "linear-gradient(135deg, #faf5ff 0%, #fdf2f8 30%, #f0f9ff 60%, #fafafa 100%)",
        padding: "100px 0",
      }}
    >
      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
        <ScrollReveal>
          <div style={{ maxWidth: "640px", margin: "0 auto" }}>
            <h2
              className="font-display"
              style={{ color: "#111827", fontSize: "clamp(24px, 3.5vw, 36px)", fontWeight: 800, lineHeight: 1.2 }}
            >
              Your Audience Is Already Worth{" "}
              <span style={{ color: "#F59E0B" }}>More Than You Think.</span>
            </h2>
            <p style={{ fontSize: "18px", color: "#6B7280", lineHeight: 1.6, marginTop: "16px" }}>
              Stop waiting to "get big enough." Start building income from the audience you already have.
            </p>

            <div className="flex flex-col items-center mt-8">
              <a href="#pricing">
                <button
                  className="group flex items-center gap-2 transition-all duration-200 hover:scale-[1.03] active:scale-[0.97]"
                  style={{
                    background: "#7C3AED",
                    color: "white",
                    padding: "18px 40px",
                    borderRadius: "12px",
                    fontWeight: 700,
                    fontSize: "18px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Start Your Free Trial — $0 Today
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </a>
              <p style={{ fontSize: "14px", color: "#9CA3AF", marginTop: "12px" }}>
                No credit card required. 7-day free trial. Cancel anytime.
              </p>
            </div>
          </div>

          {/* Product image placeholder */}
          <div className="relative" style={{ maxWidth: "900px", margin: "48px auto 0" }}>
            {/* Glow */}
            <div
              className="absolute"
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
                height: "80%",
                background: "radial-gradient(ellipse, rgba(124, 58, 237, 0.08) 0%, transparent 70%)",
                filter: "blur(40px)",
                zIndex: 0,
              }}
            />
            <div
              className="relative flex items-center justify-center"
              style={{
                aspectRatio: "16/10",
                borderRadius: "16px",
                background: "#F3F4F6",
                border: "1px solid #E5E7EB",
                boxShadow: "0 8px 40px rgba(0,0,0,0.06)",
                transform: "perspective(1200px) rotateX(4deg)",
                zIndex: 1,
              }}
            >
              <p style={{ color: "#9CA3AF", fontSize: "14px" }}>Product screenshot — image placeholder</p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
